import React from "react";
import { number } from "prop-types";

const DefaultMobileLogo = ({ width = 155, height = 35 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <g id="Group_3178" data-name="Group 3178" transform="translate(-343.998 -668.83)">
      <path
        id="Path_89"
        d="M421.5 693.875a9.521 9.521 0 1 0-9.519-9.518 9.52 9.52 0 0 0 9.519 9.518z"
        className="cls-1"
        style={{ fill: "#ee4023" }}
        data-name="Path 89"
      />
      <g id="Group_3172" data-name="Group 3172">
        <path
          id="Rectangle_547"
          d="M0 0h.969v4.737H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 547"
          transform="rotate(-.065 589767.266 -370776.479)"
        />
      </g>
      <g id="Group_3173" data-name="Group 3173">
        <path
          id="Rectangle_548"
          d="M0 0h4.767v.97H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 548"
          transform="rotate(-60.954 786.558 -24.982)"
        />
      </g>
      <g id="Group_3174" data-name="Group 3174">
        <path
          id="Rectangle_549"
          d="M0 0h4.737v.97H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 549"
          transform="rotate(-31.57 1414.105 -422.012)"
        />
      </g>
      <g id="Group_3175" data-name="Group 3175">
        <path
          id="Rectangle_550"
          d="M0 0h.97v4.723H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 550"
          transform="rotate(-29.2 1494.389 -458.36)"
        />
      </g>
      <g id="Group_3176" data-name="Group 3176">
        <path
          id="Rectangle_551"
          d="M0 0h.97v4.704H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 551"
          transform="rotate(-59.23 799.444 -20.622)"
        />
      </g>
      <g id="Group_3177" data-name="Group 3177">
        <path
          id="Path_90"
          d="M382.013 686.691c-7.717 4.981-10.606 6.4-10.606 6.4v4.89c9.885-4.684 15.946 1.29 15.946 1.29v1.675h4.629v-14.2a2.713 2.713 0 0 0-1.5-2.466h8.3a17.526 17.526 0 0 0-3.6 1.452 2.286 2.286 0 0 0-1 2.234l5.657 2.35s.692.2.717.7c.041.592-.72.777-.72.777s-3.259.253-4.887 1.587c-1.173.966-.9 1.8-.9 1.8v2.43c0 .206 0 .374.108.479a7.874 7.874 0 0 0 3.758 1.746l2-1.09c-2.107-.16-2.2-.643-2.231-1.053-.016-.328.327-1.383 4.74-1.61 3.951-.2 7.837 2.633 7.837 2.633v2.216h4.621v-14.089c0-.815-.225-4.086-4.365-4.086l-4.031-.028H384.4v.646c3 .3 2.947 2.341 2.947 2.341v9.931a13.567 13.567 0 0 0-7.558-3.021 29.144 29.144 0 0 0 4.9-3.486 1.549 1.549 0 0 0 .259-1.93 11.452 11.452 0 0 0-2.91-3.938 4.413 4.413 0 0 0-4.5-.614l-2.458 1.109c-6.307-3.537-10.053-.253-10.053-.253v.726c-9.756-6.5-16.341 1.75-16.341 1.75v2.111l6.631-.017-2.726 2.6v3.655l12.262-4.563v6.254a8.239 8.239 0 0 0-5.982-1.029c-2.081.461-5.256 1.686-6.154 1.727-4.085.182-4.355-2.7-4.4-4.168-.034-1.046 1.162-.89 1.162-.89v-1.8h-5.325a13.194 13.194 0 0 0-.091 3.17c.454 4.413 2.983 6.15 5.169 6.628 4.216.923 7.109-1.705 9.914-1.951a7.607 7.607 0 0 1 5.69 2.056v1.041h4.627v-15.447a1.751 1.751 0 0 1 1.2-1.144 4.209 4.209 0 0 1 2.829.165 11.681 11.681 0 0 0-1.443.937c-.82.593-.516 1.831-.456 2.826s1.81 1.7 1.81 1.7l1.486-.728c-1.358-.448-.543-1.3-.543-1.3s5.243-2.445 6.148-2.837a4.427 4.427 0 0 1 .484-.189.7.7 0 0 1 .93.38c.211.445.532 1.239.105 1.515zM358.2 688.83s-.349.219-.536.013c-.09-.088-.033-.254.171-.45l1.061-.975s.931-.869-.366-.933-3.268-.054-3.268-.054-.613.076-.656-.2a.375.375 0 0 1 .2-.435c.517-.337 8.294-2.115 10.443.51zm49.471 2.271s.36-1.313-2.207-2.428c-.339-.149-2.614-1.193-4.837-2.1a.558.558 0 0 1 .117-1.055c.667-.241 4.215-1.236 4.215-1.236h3.1a2.143 2.143 0 0 1 2.191 2.153l.01 8.573a12.888 12.888 0 0 0-5.277-2.788z"
          className="cls-2"
          style={{ fill: "#231f20", fillRule: "evenodd" }}
          data-name="Path 90"
        />
      </g>
      <path
        id="Path_91"
        d="M495.17 682.67h-68.615v1.752h4.847c-5.215 1.592-4.678 4.193-4.678 4.193v4.562c.127 2.28 2.742 2.025 2.742 2.025a24.631 24.631 0 0 0 4.213-1.056 10.969 10.969 0 0 0 2.744-1.2 1.946 1.946 0 0 0 1.212-2.665 8.9 8.9 0 0 0-2.089-2.436l-1.883.588.413.408c.7.51-.593 1.208-.593 1.208l-3.008.951c-1.554.368-1.029-.749-.95-.9.424-.956 2.3-1.858 2.95-2.2 4.777-2.528 5.951-.443 6.5.147 3.6 3.841.152 6.835-.6 7.505a14.611 14.611 0 0 1-9.7 3.928c-4.686.054-5.774-2.206-5.774-2.206l.435-1.042-1.684-.868-3.861 4.6c14.314 9.766 24.486-2.945 24.486-2.945a8.379 8.379 0 0 1 3.519 2.307v1.487h4.5V686.83c-.032-2.069-1.4-2.41-1.4-2.41h3.05a2.384 2.384 0 0 1 1.429 2.435v13.958h4.675v-14.162c-.019-2.015-1.489-2.231-1.489-2.231h10.17c-.86.571-1.753 1.256-3.981 2.937a4.62 4.62 0 0 0-1.868 4.024v4.433a3.245 3.245 0 0 0 1.141 2.159 20.06 20.06 0 0 0 6.641 3.614c3.482 1.022 5.267-1.037 5.267-1.037l1.608-1.731-1.654-.894c-1.18 1.869-4.14-.144-4.14-.144s-1.858-1.1-2.652-1.577c-2.3-1.467-2.253-2.117-2.253-2.117l.021-5.062c.213-1.525 5.451-4.605 5.451-4.605h15.143a2.458 2.458 0 0 1 1.582 2.541v3.028c-2.231-1.723-3.937-.7-3.937-.7l-2.8 1.4 1.558-2.205c.8-1.135-.31-1.494-2.712-2.6-3.1-1.429-5.022.066-5.022.066a37.291 37.291 0 0 0-3.92 2.491c-2 1.467-1.822 2.891-1.822 2.891v2.2c1.109 1.874 3.713 1.3 3.713 1.3l.637-1.261c-1.635-.1-1.325-.83-1.1-1.108 0 0 6.258-3.817 7.4-4.414.17-.088.555.052.4.384-.594 1.287-3.177 4.336-3.353 4.776-1.083 2.784.8 3.526.8 3.526l7.7-3.8c2-.958 2.445.495 2.445.495v7.58h4.491v-14.049a2.578 2.578 0 0 0-1.571-2.541h3.024a2.594 2.594 0 0 1 1.6 2.551v14.038H499v-14.051c0-1.729-.865-4.288-3.83-4.288zm-49.37 12.591a6.411 6.411 0 0 0-2.148-1.9 8.91 8.91 0 0 0-6.228-8.936h7s1.356.341 1.378 2.425z"
        className="cls-2"
        style={{ fill: "#231f20", fillRule: "evenodd" }}
        data-name="Path 91"
      />
    </g>
  </svg>
);

DefaultMobileLogo.propTypes = {
  width: number,
  height: number
};

export default DefaultMobileLogo;
